import { useState } from 'react';

const SUBSCRIBE_TOPICS = [
  { id: 'policy', label: '监管政策', icon: 'ri-government-line', color: '#7C3AED', desc: '香港SFC、MAS、SEC等最新监管动态' },
  { id: 'market', label: '市场动态', icon: 'ri-line-chart-line', color: '#10B981', desc: 'RWA市场规模、机构动向、融资资讯' },
  { id: 'conference', label: '行业会议', icon: 'ri-calendar-event-line', color: '#F59E0B', desc: '全球RWA峰会、论坛、黑客松预告' },
  { id: 'education', label: '教育资源', icon: 'ri-graduation-cap-line', color: '#EF4444', desc: '高校课程、研究报告、学术论文' },
  { id: 'tech', label: '技术前沿', icon: 'ri-cpu-line', color: '#0EA5E9', desc: '区块链协议升级、RWA技术方案' },
  { id: 'case', label: '案例解析', icon: 'ri-file-chart-line', color: '#F97316', desc: '真实RWA项目拆解与合规分析' },
];

const FREQ_OPTIONS = [
  { id: 'daily', label: '每日精选', icon: 'ri-sun-line' },
  { id: 'weekly', label: '每周汇总', icon: 'ri-calendar-line' },
  { id: 'monthly', label: '月度深度', icon: 'ri-calendar-2-line' },
];

const universities = [
  { name: '香港大学（HKU）', dept: '经济及工商管理学院', course: 'FinTech与数字资产研究中心，开设RWA专题讲座及区块链金融课程', level: '研究生/专业课程', url: 'https://www.hku.hk', color: '#7C3AED' },
  { name: '香港科技大学（HKUST）', dept: 'HKUST Business School', course: 'Blockchain & FinTech项目，每年举办全球DeFi黑客松及RWA研究论坛', level: '本科/研究生', url: 'https://hkust.edu.hk', color: '#F59E0B' },
  { name: '香港中文大学（CUHK）', dept: '财务学系', course: 'Blockchain Finance课程，与HashKey合作RWA政策研究项目', level: '研究生', url: 'https://www.cuhk.edu.hk', color: '#34D399' },
  { name: '北京大学汇丰商学院', dept: '金融学系', course: '数字金融与区块链专题，深圳校区数字经济研究院持续跟进RWA', level: '研究生/MBA', url: 'https://www.phbs.pku.edu.cn', color: '#FB923C' },
  { name: '清华大学五道口金融学院', dept: '金融科技方向', course: 'PBCSF设立金融科技项目，涵盖监管科技与数字资产合规研究', level: '研究生/博士', url: 'https://www.pbcsf.tsinghua.edu.cn', color: '#60A5FA' },
  { name: 'MIT Digital Currency Initiative', dept: 'MIT Media Lab合作项目', course: '与香港高校联合研究CBDC与RWA代币化底层技术及监管框架', level: '研究/博士后', url: 'https://dci.mit.edu', color: '#C084FC' },
];

const news = [
  { date: '2026.03', tag: '政策', title: '香港SFC更新VASP发牌条件，明确RWA代币二级市场规则', source: 'SFC官网', sourceUrl: 'https://www.sfc.hk' },
  { date: '2026.02', tag: '市场', title: '贝莱德BUIDL基金规模突破10亿美元，机构RWA配置加速', source: 'CoinDesk', sourceUrl: 'https://www.coindesk.com' },
  { date: '2026.01', tag: '会议', title: 'RWA Summit Hong Kong 2026 圆满落幕，87家机构签约', source: 'RWA99.cn', sourceUrl: '#' },
  { date: '2025.12', tag: '政策', title: '欧盟MiCA条例全面生效，资产参考代币发行须托管100%储备', source: 'ESMA', sourceUrl: 'https://www.esma.europa.eu' },
  { date: '2025.11', tag: '市场', title: 'Ondo Finance完成C轮融资，估值达50亿美元，聚焦亚太扩张', source: 'Bloomberg', sourceUrl: 'https://bloomberg.com' },
  { date: '2025.10', tag: '会议', title: 'Hong Kong Fintech Week 2025，RWA专场吸引2000+专业人士', source: 'HKMA', sourceUrl: 'https://www.hkma.gov.hk' },
  { date: '2025.09', tag: '政策', title: '新加坡MAS发布Project Guardian第三期报告，覆盖外汇RWA结算', source: 'MAS', sourceUrl: 'https://www.mas.gov.sg' },
  { date: '2025.08', tag: '市场', title: '全球RWA链上资产总值突破300亿美元，较年初增长220%', source: 'RWA.xyz', sourceUrl: 'https://rwa.xyz' },
];

const upcomingConferences = [
  { date: '2026.04.15', name: 'Hong Kong RWA Summit Spring', location: '香港会议展览中心', type: '峰会', url: 'https://www.hkex.com.hk' },
  { date: '2026.05.20', name: 'Singapore FinTech Festival Side Event', location: '新加坡滨海湾金沙', type: '会议', url: 'https://fintechfestival.sg' },
  { date: '2026.06.10', name: 'RWA Asia Forum', location: '香港九龙', type: '论坛', url: '#' },
  { date: '2026.09.18', name: 'Consensus Hong Kong', location: '香港会议展览中心', type: '行业峰会', url: 'https://consensus.coindesk.com' },
];

const tagColors: Record<string, string> = {
  政策: 'bg-[#7C3AED]/10 text-[#7C3AED]',
  市场: 'bg-emerald-50 text-emerald-700',
  会议: 'bg-amber-50 text-amber-700',
};

const confTypeColors: Record<string, string> = {
  峰会: 'bg-[#7C3AED]/10 text-[#7C3AED]',
  会议: 'bg-emerald-50 text-emerald-700',
  论坛: 'bg-pink-50 text-pink-700',
  行业峰会: 'bg-amber-50 text-amber-700',
};

export default function EducationNews() {
  const [showSubscribe, setShowSubscribe] = useState(false);
  const [selectedTopics, setSelectedTopics] = useState<string[]>([]);
  const [freq, setFreq] = useState('weekly');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [subError, setSubError] = useState('');

  const toggleTopic = (id: string) => {
    setSelectedTopics((prev) => prev.includes(id) ? prev.filter((t) => t !== id) : [...prev, id]);
  };

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubError('');
    const form = e.currentTarget;
    const email = (form.elements.namedItem('email') as HTMLInputElement)?.value.trim();
    if (!email) { setSubError('请填写邮箱地址'); return; }
    if (selectedTopics.length === 0) { setSubError('请至少选择一个订阅主题'); return; }
    setSubmitting(true);
    try {
      const body = new URLSearchParams();
      body.append('email', email);
      body.append('topics', selectedTopics.map((id) => SUBSCRIBE_TOPICS.find((t) => t.id === id)?.label || id).join('、'));
      body.append('frequency', FREQ_OPTIONS.find((f) => f.id === freq)?.label || freq);
      const res = await fetch('https://readdy.ai/api/form/d7alv62bdfubkqslapb0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      if (res.ok) { setSubmitted(true); } else { setSubError('提交失败，请稍后重试'); }
    } catch { setSubError('网络错误，请稍后重试'); } finally { setSubmitting(false); }
  };

  return (
    <>
      {/* ======= 09 高校与教育 ======= */}
      <section id="education" className="py-20 bg-white">
        <div className="max-w-[1440px] mx-auto px-4 lg:px-8">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-[#7C3AED]/8 border border-[#7C3AED]/15 rounded-full mb-4">
              <i className="ri-graduation-cap-line text-[#7C3AED] text-sm"></i>
              <span className="text-[#7C3AED] text-sm font-semibold">09 · 高校与教育</span>
            </div>
            <h2 className="text-3xl lg:text-4xl font-black text-gray-900 mb-4">高校 RWA 教育资源导航</h2>
            <p className="text-gray-500 max-w-xl mx-auto text-base">
              整合两岸三地及国际顶尖院校的RWA与区块链金融相关课程、研究资源。
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {universities.map((u) => (
              <div key={u.name} className="bg-[#F5F3FF] border border-[#7C3AED]/8 rounded-xl p-5 hover:border-[#7C3AED]/30 hover:-translate-y-0.5 transition-all group">
                <div className="flex items-start gap-3 mb-3">
                  <div
                    className="w-10 h-10 flex items-center justify-center rounded-xl shrink-0"
                    style={{ background: `${u.color}20`, border: `1px solid ${u.color}30` }}
                  >
                    <i className="ri-graduation-cap-fill text-lg" style={{ color: u.color }}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="font-black text-gray-800 text-sm group-hover:text-[#7C3AED] transition-colors">{u.name}</h4>
                    <div className="text-xs font-medium mt-0.5" style={{ color: u.color }}>{u.dept}</div>
                  </div>
                </div>
                <p className="text-gray-500 text-xs leading-relaxed mb-3">{u.course}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs px-2 py-0.5 rounded-full font-medium bg-white border border-gray-100 text-gray-500">{u.level}</span>
                  <a
                    href={u.url}
                    target="_blank"
                    rel="nofollow noreferrer"
                    className="text-xs flex items-center gap-1 hover:underline cursor-pointer"
                    style={{ color: u.color }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <i className="ri-external-link-line text-xs"></i>
                    官网
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ======= 10 资讯与会议 ======= */}
      <section id="news" className="py-20 bg-[#F5F3FF]">
        <div className="max-w-[1440px] mx-auto px-4 lg:px-8">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-[#7C3AED]/8 border border-[#7C3AED]/15 rounded-full mb-4">
              <i className="ri-news-line text-[#7C3AED] text-sm"></i>
              <span className="text-[#7C3AED] text-sm font-semibold">10 · 资讯与官方会议</span>
            </div>
            <h2 className="text-3xl lg:text-4xl font-black text-gray-900 mb-4">RWA 最新资讯 &amp; 行业会议</h2>
            <p className="text-gray-500 max-w-xl mx-auto text-base mb-6">来源均为官方可溯源渠道，禁止虚构任何活动或数据</p>
            <button
              onClick={() => setShowSubscribe(true)}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-bold text-white cursor-pointer whitespace-nowrap transition-opacity hover:opacity-90"
              style={{ background: 'linear-gradient(135deg, #7C3AED, #F59E0B)' }}
            >
              <i className="ri-notification-3-line"></i>
              订阅感兴趣的主题推送
            </button>
          </div>

          <div className="grid lg:grid-cols-3 gap-8">
            {/* News List */}
            <div className="lg:col-span-2 space-y-3">
              {news.map((n, i) => (
                <div
                  key={i}
                  className="bg-white border border-gray-100 rounded-xl px-5 py-4 flex items-center gap-4 hover:border-[#7C3AED]/25 transition-all cursor-pointer group"
                >
                  <div className="text-xs text-gray-400 font-medium whitespace-nowrap shrink-0 w-16">{n.date}</div>
                  <span className={`text-xs px-2 py-0.5 rounded-full font-medium shrink-0 ${tagColors[n.tag]}`}>{n.tag}</span>
                  <div className="font-medium text-gray-800 text-sm leading-snug flex-1 group-hover:text-[#7C3AED] transition-colors">{n.title}</div>
                  <a
                    href={n.sourceUrl}
                    target="_blank"
                    rel="nofollow noreferrer"
                    className="text-xs text-[#7C3AED] hover:underline shrink-0 hidden md:flex items-center gap-1"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {n.source}
                    <i className="ri-external-link-line text-xs ml-0.5"></i>
                  </a>
                </div>
              ))}
            </div>

            {/* Upcoming Conferences */}
            <div className="space-y-3">
              <div className="flex items-center gap-2 mb-1">
                <i className="ri-calendar-event-line text-[#7C3AED] text-sm"></i>
                <h3 className="font-black text-gray-700 text-sm">近期官方会议</h3>
              </div>
              {upcomingConferences.map((c, i) => (
                <div key={i} className="bg-white border border-gray-100 rounded-xl p-4 hover:border-[#7C3AED]/25 transition-all group">
                  <div className="flex items-start justify-between mb-2">
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${confTypeColors[c.type]}`}>{c.type}</span>
                    <span className="text-xs font-bold text-[#7C3AED]">{c.date}</span>
                  </div>
                  <h4 className="font-bold text-gray-800 text-sm mb-1.5 group-hover:text-[#7C3AED] transition-colors leading-snug">{c.name}</h4>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-1 text-xs text-gray-400">
                      <i className="ri-map-pin-line text-xs"></i>
                      {c.location}
                    </div>
                    {c.url !== '#' && (
                      <a href={c.url} target="_blank" rel="nofollow noreferrer" className="text-xs text-[#7C3AED] hover:underline flex items-center gap-0.5">
                        了解
                        <i className="ri-arrow-right-line text-xs"></i>
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      {showSubscribe && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setShowSubscribe(false)}>
          <div className="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>
          <div className="relative bg-white rounded-2xl w-full max-w-lg shadow-2xl max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="px-6 pt-6 pb-4 border-b border-gray-100 flex items-center justify-between">
              <div>
                <h3 className="font-black text-gray-900 text-base flex items-center gap-2">
                  <i className="ri-notification-3-line text-[#7C3AED]"></i>内容订阅
                </h3>
                <p className="text-xs text-gray-400 mt-0.5">按主题订阅，定期推送最新RWA资讯</p>
              </div>
              <button onClick={() => setShowSubscribe(false)} className="w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:bg-gray-100 cursor-pointer">
                <i className="ri-close-line text-lg"></i>
              </button>
            </div>
            <div className="px-6 py-5">
              {submitted ? (
                <div className="text-center py-8">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#7C3AED]/10 mx-auto mb-4">
                    <i className="ri-checkbox-circle-line text-3xl text-[#7C3AED]"></i>
                  </div>
                  <h4 className="font-black text-gray-900 text-lg mb-2">订阅成功！</h4>
                  <p className="text-gray-500 text-sm mb-6">我们将按您选择的频率，推送您感兴趣的RWA资讯到您的邮箱。</p>
                  <button onClick={() => setShowSubscribe(false)} className="px-6 py-2.5 rounded-xl text-sm font-bold text-white bg-[#7C3AED] cursor-pointer whitespace-nowrap">关闭</button>
                </div>
              ) : (
                <form data-readdy-form onSubmit={handleSubscribe} className="space-y-5">
                  <div>
                    <label className="block text-xs font-bold text-gray-700 mb-1.5">邮箱地址 <span className="text-red-500">*</span></label>
                    <input name="email" type="email" placeholder="your@email.com" className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#7C3AED]/50 transition-colors" />
                  </div>
                  <div>
                    <label className="block text-xs font-bold text-gray-700 mb-2">订阅主题 <span className="text-red-500">*</span> <span className="text-gray-400 font-normal">（可多选）</span></label>
                    <div className="grid grid-cols-2 gap-2">
                      {SUBSCRIBE_TOPICS.map((topic) => {
                        const active = selectedTopics.includes(topic.id);
                        return (
                          <button key={topic.id} type="button" onClick={() => toggleTopic(topic.id)}
                            className="flex items-start gap-2.5 p-3 rounded-xl border text-left transition-all cursor-pointer"
                            style={active ? { background: `${topic.color}10`, borderColor: `${topic.color}40` } : { background: '#fff', borderColor: '#E5E7EB' }}>
                            <div className="w-7 h-7 flex items-center justify-center rounded-lg shrink-0" style={{ background: active ? topic.color : '#F3F4F6' }}>
                              <i className={`${topic.icon} text-xs`} style={{ color: active ? '#fff' : '#9CA3AF' }}></i>
                            </div>
                            <div>
                              <div className="text-xs font-bold" style={{ color: active ? topic.color : '#374151' }}>{topic.label}</div>
                              <div className="text-[10px] text-gray-400 leading-tight mt-0.5">{topic.desc}</div>
                            </div>
                          </button>
                        );
                      })}
                    </div>
                  </div>
                  <div>
                    <label className="block text-xs font-bold text-gray-700 mb-2">推送频率</label>
                    <div className="flex gap-2">
                      {FREQ_OPTIONS.map((f) => (
                        <button key={f.id} type="button" onClick={() => setFreq(f.id)}
                          className="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-lg text-xs font-bold border transition-all cursor-pointer"
                          style={freq === f.id ? { background: '#7C3AED', color: '#fff', borderColor: '#7C3AED' } : { background: '#fff', color: '#6B7280', borderColor: '#E5E7EB' }}>
                          <i className={f.icon}></i>{f.label}
                        </button>
                      ))}
                    </div>
                  </div>
                  {subError && <div className="flex items-center gap-2 text-red-500 text-xs bg-red-50 rounded-lg px-3 py-2"><i className="ri-error-warning-line"></i>{subError}</div>}
                  <button type="submit" disabled={submitting}
                    className="w-full py-3 rounded-xl text-sm font-bold text-white cursor-pointer whitespace-nowrap disabled:opacity-60"
                    style={{ background: 'linear-gradient(135deg, #7C3AED, #F59E0B)' }}>
                    {submitting ? <span className="flex items-center justify-center gap-2"><i className="ri-loader-4-line animate-spin"></i>提交中...</span> : <span className="flex items-center justify-center gap-2"><i className="ri-notification-3-line"></i>立即订阅</span>}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
